// extracted by mini-css-extract-plugin
export default {"projectsBlock":"Projects_projectsBlock__JslQx","projectsContainer":"Projects_projectsContainer__B9LiG","projects":"Projects_projects__CH5tm"};